const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0429688,0,0,0.0429688,1.00002,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C173.564,0.094 106.761,66.898 106.667,149.333L106.667,245.333C106.667,251.224 111.443,256 117.334,256C123.225,256 128,251.224 128,245.333L149.333,245.333C149.333,251.224 154.109,256 160,256C165.891,256 170.667,251.224 170.667,245.333L170.667,149.333C170.667,102.205 208.872,64 256,64C303.128,64 341.333,102.205 341.333,149.333L341.333,156.121C341.333,162.012 346.109,166.788 352,166.788L394.667,166.788C400.558,166.788 405.334,162.012 405.334,156.121L405.334,149.333C405.239,66.898 338.436,0.094 256,0Z",
    style: {
      fill: "rgb(69,90,100)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.667,234.667L117.333,234.667C99.66,234.667 85.333,248.994 85.333,266.667L85.333,458.667C85.333,488.122 109.211,512 138.666,512L373.333,512C402.788,512 426.666,488.122 426.666,458.667L426.666,266.667C426.667,248.994 412.34,234.667 394.667,234.667Z",
    style: {
      fill: "rgb(255,193,7)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8,372.693C293.664,364.682 298.705,353.281 298.667,341.333C298.667,317.769 279.564,298.666 256,298.666C232.436,298.666 213.333,317.769 213.333,341.333C213.295,353.281 218.336,364.682 227.2,372.693L213.888,412.629C212.026,418.218 215.048,424.258 220.637,426.12C221.721,426.481 222.857,426.666 224,426.667L288,426.667C293.891,426.663 298.663,421.883 298.659,415.992C298.658,414.849 298.474,413.714 298.112,412.629L284.8,372.693Z",
    style: {
      fill: "rgb(69,90,100)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.2573d198cfeefa999b0fec87b856c64e.svg";
export { ForwardRef as ReactComponent };